<div    class="check {{getCheckedCls()}}"  attr.data-testid="{{testId}}-checkbox" style.top="{{checkTop}}px" (click)="onClick()">

     
</div>
<span [width]="5"></span>
<span class="{{labelClass}}">{{label}}</span>
